import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../commonComponents/translate';
import Anchor from '../../commonComponents/Anchor';
import journeyProp from './propTypes/journeyProp';
import AcademyFooterContainer from '../../commonComponents/container/AcademyFooterContainer';
import CertificateIcon from '../../commonComponents/icons/CertificateIcon';

function SessionsCarouselItem({ t, className, journey }) {
  const image = journey.imageSquare || journey.image;
  const imageURL = image && image.thumb ? image.thumb : '/images/no_image_upload.png';

  const containerClass = cx(
    'm-portlet',
    'm-portlet--rounded',
    'm-portlet--rounded-force',
    'journey-enrolled-item',
    className,
  );

  const { steps, certificate } = journey;

  return (
    <div className={containerClass}>
      <div className="img-journey">
        <img
          itemProp="image"
          content={imageURL}
          src={imageURL}
          alt={journey.title}
        />
      </div>
      <div className="body-card_journey">
        <div className="journey-title">
          <h5 className="title-card_journey journey-fix-carousel-margins">
            {journey.title}
          </h5>
        </div>
        <div className="journey-info">
          {steps?.length > 0 &&
            <AcademyFooterContainer faIcon="la la-list" text={t('journey.number.of.steps', steps.length || 0)} />
          }
          {certificate && certificate.enabled &&
            <AcademyFooterContainer
              customIcon={<CertificateIcon />}
              text={t('reward.certificate')}
            />
          }
        </div>
        <div className="journey-actions">
          <Anchor
            href={`/journey/${journey.slug}`}
            className="btn m-btn--pill btn-dynamic navigation-button"
          >
            {t('academy.open.journey')}
          </Anchor>
        </div>
      </div>
    </div>
  );
}

SessionsCarouselItem.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
  journey: PropTypes.shape(journeyProp.propType).isRequired,
};

SessionsCarouselItem.defaultProps = {
  className: '',
};

export default translate(SessionsCarouselItem);
